export enum UserModule {
  PIONEER = 'PIONEER',
  ARGENTIA = 'ARGENTIA',
  PROGNOSS = 'PROGNOSS'
}
